import { Controller } from "@hotwired/stimulus"

// Plays the hero video only when motion is welcome. The <video> ships WITHOUT an
// `autoplay` attribute, so prefers-reduced-motion / Save-Data users (and the
// no-JS path) get just the poster image — no flash of motion to stop after the
// fact. Muted playback started from JS is allowed by autoplay policies.
export default class extends Controller {
  connect() {
    if (!this.#reduceMotion) this.element.play().catch(() => {})
  }

  get #reduceMotion() {
    return (
      window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
      navigator.connection?.saveData === true
    )
  }
}
